import * as ActionTypes from '../constants/actionTypes'
import { userGetSellerMenu, userUpdateSellerMenu } from '../api/user'

export const editSellerMenuForm = formFieldsChange => ({
  type: ActionTypes.USERSELLERMENUFORM_EDITFORM_CHANGE,
  field: formFieldsChange,
})

export const reset = () => ({
  type: ActionTypes.USERSELLERMENUFORM_ENTER_RESET,
})

export const fetchItems = values => (dispatch) => {
  dispatch({ type: ActionTypes.USERSELLERMENUFORM_FETCHITEMS_LOAD })

  userGetSellerMenu(values).then((res) => {
    const items = res.result

    dispatch({
      type: ActionTypes.USERSELLERMENUFORM_FETCHITEMS_SUCCEED,
      items,
    })
    dispatch({
      type: ActionTypes.USERSELLERMENUFORM_EDITFORM_CHANGE,
      fields: items,
      field: {
        idnum: { name: 'idnum', value: items[0].idnum },
        n_enable: { name: 'n_enable', value: !!items[0].n_enable },
      },
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.USERSELLERMENUFORM_FETCHITEMS_FAIL,
      fetchSellerMenuItemsError: 'Ошибка получения данных.',
    })
  })
}

export const editItem = values => (dispatch) => {
  dispatch({ type: ActionTypes.USERSELLERMENUFORM_EDITITEM_LOAD })

  userUpdateSellerMenu(values).then(() => {
    dispatch({ type: ActionTypes.USERSELLERMENUFORM_EDITITEM_SUCCEED })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.USERSELLERMENUFORM_EDITITEM_FAIL,
      editSellerMenuItemError: 'Ошибка изменения данных.',
    })
  })
}



// WEBPACK FOOTER //
// src/actions/userSellerMenuForm.js